import { ChannelTypes } from 'conversations-internal-schema/constants/ChannelTypes';
export const checkChannelAssignsToAvailable = channelType => channelType === ChannelTypes.CHAT || channelType === ChannelTypes.FACEBOOK_MESSENGER;